export enum FeatureToggleVariants {
  enabled = 'enabled',
  disabled = 'disabled',
}
